import React from "react"
import { Box, Typography } from "@mui/material"


export default function RealTimeTableTitle({ timeStamp }) {

	return <Box sx={{
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "flex-start"
	}}>
		<Typography variant="title">Real Time Searches:</Typography>
		<Typography variant="subtitle1" sx={{ fontWeight: "light", color: "secondary.main" }}>{timeStamp}</Typography>
	</Box>
}